import React from "react";
import Routes from "./Routes";
import WhatsAppButton from "./components/ui/WhatsAppButton";

function App() {
  return (
    <>
      <Routes />
      <WhatsAppButton />
    </>
  );
}

export default App;